<app-ice-select-box
  label="Betal nå med tilbehørsbinding"
  radioTestId="payment-method-input"
  [control]="paymentMethodControl"
  [hideOverflow]="false"
  [value]="paymentMethodControl?.value"
>
  <app-ice-select
    buttonTestId="accessory-choose-subscription-button"
    label="Velg abonnement"
    ngDefaultControl
    placeholder=" "
    textTestId="accessory-choose-subscription-input"
    [control]="newSubscriptionIdControl"
    [options]="offeringOptions"
  />
</app-ice-select-box>
